<div class="availability-summary-container" [ngClass]="displayMode()">
	@for (summary of summaries()!; track $index) {
		<md-content-box class="availability-summary" [ngClass]="type()" (click)="handleCardClick(summary)">
			<div class="date-range">
				{{ summary.availabilityRange }}
			</div>
			<div class="hour-total">
				<md-icon>schedule</md-icon>
				{{ timeDisplayForSummary(summary) }}
			</div>
		</md-content-box>
	}
</div>
